module.exports = __webpack_public_path__ + "static/img/BU02PB-1.69cef00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/BU02PB-1.jpg
// module id = pfC7
// module chunks = 1